// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-item[data-v-bf1740be] {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
